var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6102 19.6083H10.5932L24.5763 5.61751C25.8475 4.34562 25.8475 2.22581 24.5763 0.953917C23.3051 -0.317972 21.1864 -0.317972 19.9153 0.953917L0.847458 20.0323C0 20.8802 0 22.1521 0 23C0 23.8479 0 25.1198 0.847458 25.9677L19.9153 45.0461C21.1864 46.318 23.3051 46.318 24.5763 45.0461C25.8475 43.7742 25.8475 41.6544 24.5763 40.3825L10.5932 26.3917H46.6102C48.3051 26.3917 50 24.6959 50 23C50 21.3041 48.3051 19.6083 46.6102 19.6083Z",
    fill: "#FF7919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrow2);
export default __webpack_public_path__ + "static/media/newArrow2.ccc002a556423972b1bad1b7c6438d0a.svg";
export { ForwardRef as ReactComponent };